











import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { FalconPaymentStatus } from "@/enums/falcon/falcon-payment-status.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon payments filters status form field component.
 * It is responsible for delivering paymentStatus filter option value
 */
@Component({
  filters: {
    ...capitalizeFilter
  }
})
export default class PaymentsFiltersStatusFormField extends Vue {
  @Prop() private setPaymentStatus!: (
    paymentStatus: FalconPaymentStatus
  ) => void;
  private paymentStatus: FalconPaymentStatus = FalconPaymentStatus.Unsettled;

  paymentStatusEnum = FalconPaymentStatus;
  i18nMessageKeyEnum = I18nMessageKey;

  mounted(): void {
    this.paymentStatusUpdated();
  }

  private paymentStatusUpdated(): void {
    this.setPaymentStatus(this.paymentStatus);
  }
}
